import React from "react";

import clsx from "clsx";
import { Link, useParams } from "react-router-dom";

interface LabelRoute {
  label: string | React.ReactElement;
  route: string;
  adminOnly?: boolean;
}
interface PageNavigatorProps {
  title: string;
  orderedLabelRoutes: LabelRoute[];
}

export const PageNavigator = ({
  title,
  orderedLabelRoutes,
}: PageNavigatorProps) => {
  const params = useParams();
  const isSectionActive = (route: string) =>
    Object.values(params).includes(route);

  return (
    <ul className="page-navigator list-group rounded-md">
      <li className="list-group-item border-b-transparent">
        <b>{title}</b>
      </li>
      {orderedLabelRoutes.map((labelRoute) => {
        return (
          <Link
            to={`${labelRoute.route}`}
            className="no-link-style"
            key={labelRoute.route}
          >
            <li
              className={clsx(
                "list-group-item list-group-item-action border-b-transparent hover:bg-cosmic-4",
                {
                  "bg-cosmic-4 font-semibold border-l-cosmic": isSectionActive(
                    labelRoute.route,
                  ),
                },
              )}
            >
              {labelRoute.label}
              {labelRoute.adminOnly && (
                <span className="m-2">
                  <i className="fa-regular fa-sharp fa-user"></i>
                </span>
              )}
            </li>
          </Link>
        );
      })}
    </ul>
  );
};
